import { RootState } from 'models/store';

// ==============================|| APP SELECTORS ||============================== //

export const selectSnackbar = (state: RootState) => state.app.snackbar;

export const selectIsDrawerOpen = (state: RootState) =>
  state.app.menu.drawerOpen;

export const selectActiveItem = (state: RootState) =>
  state.app.menu.selectedItem;

export const selectActiveID = (state: RootState) => state.app.menu.selectedID;

export const selectAjaxLoader = (state: RootState) =>
  state.app.ajaxLoader !== 0;

export const selectAjaxLoaderCount = (state: RootState) => state.app.ajaxLoader;

export const selectAppErrorId = (state: RootState) => state.app.appErrorId;
